<template>
  <div class="text-black position-relative">
    <VNuxtLink
      to="/ekooperativa-fo"
      :label="$t('eKooperativa')"
      class="text-black stretched-link d-block"
    >
      <span class="fs-xsmall mb-1 d-block">
        {{ $t('Klientsky portál') }}
      </span>
      <span class="fw-bolder">{{ $t('eKooperativa') }}</span>
    </VNuxtLink>
  </div>
</template>
